import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DoctorsList from "@/pages/Doctors/DoctorsList";
import UsersList from "@/pages/Users/UsersList";
import PostsList from "@/pages/Posts/PostsList";
import ProductsList from "@/pages/Products/ProductsList";
import ProfilePage from "@/pages/Profile/ProfilePage";
import RolesPage from "@/pages/Roles/RolesPage";
import TransactionsList from "@/pages/Transactions/TransactionsList";
import RevenuePage from "@/pages/Revenue/RevenuePage";
import WithdrawalsList from "@/pages/Withdrawals/WithdrawalsList";
import OrdersList from "@/pages/Orders/OrdersList";
import AppointmentsList from "@/pages/Appointments/AppointmentsList";
import SpecializationsPage from "@/pages/Catalog/SpecializationsPage";
import CategoriesPage from "@/pages/Catalog/CategoriesPage";
import MedicinesPage from "@/pages/Catalog/MedicinesPage";
import LabTestsPage from "@/pages/Catalog/LabTestsPage";
import SettingsPage from "@/pages/Platform/SettingsPage";
import PushPage from "@/pages/Platform/PushPage";
import AuditPage from "@/pages/Platform/AuditPage";
import PlansPage from "@/pages/Platform/PlansPage";

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      {
        path: "doctors",
        element: (
          <ProtectedRoute require="doctors.view">
            <DoctorsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "users",
        element: (
          <ProtectedRoute require="users.view">
            <UsersList />
          </ProtectedRoute>
        ),
      },
      {
        path: "posts",
        element: (
          <ProtectedRoute require="posts.view">
            <PostsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "products",
        element: (
          <ProtectedRoute require="products.view">
            <ProductsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "roles",
        element: (
          <ProtectedRoute require="roles.view">
            <RolesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "transactions",
        element: (
          <ProtectedRoute require="transactions.view">
            <TransactionsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "orders",
        element: (
          <ProtectedRoute require="orders.view">
            <OrdersList />
          </ProtectedRoute>
        ),
      },
      {
        path: "appointments",
        element: (
          <ProtectedRoute require="appointments.view">
            <AppointmentsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "revenue",
        element: (
          <ProtectedRoute require="revenue.view">
            <RevenuePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "withdrawals",
        element: (
          <ProtectedRoute require="withdrawals.view">
            <WithdrawalsList />
          </ProtectedRoute>
        ),
      },
      ...([
        ["catalog/specializations", <SpecializationsPage />],
        ["catalog/categories", <CategoriesPage />],
        ["catalog/medicines", <MedicinesPage />],
        ["catalog/lab-tests", <LabTestsPage />],
      ] as const).map(([path, page]) => ({
        path,
        element: <ProtectedRoute require="catalog.view">{page}</ProtectedRoute>,
      })),
      { path: "settings", element: <ProtectedRoute require="settings.view"><SettingsPage /></ProtectedRoute> },
      { path: "notifications", element: <ProtectedRoute require="notifications.view"><PushPage /></ProtectedRoute> },
      { path: "audit", element: <ProtectedRoute require="audit.view"><AuditPage /></ProtectedRoute> },
      { path: "plans", element: <ProtectedRoute require="plans.view"><PlansPage /></ProtectedRoute> },
      { path: "profile", element: <ProfilePage /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
